import { render, staticRenderFns } from "./TabelaDeDados.vue?vue&type=template&id=1e2c1a19&scoped=true"
import script from "./TabelaDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeDados.vue?vue&type=style&index=0&id=1e2c1a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c1a19",
  null
  
)

export default component.exports